import { Injectable } from "@angular/core";
import { LocalStorageService } from "./local-storage.service";
import { LOCAL_STORAGE_KEYS, CONSTANT_CONFIG } from "../config/constants";
import axios, { AxiosError, AxiosResponse } from "axios";
import { NotificationService } from "./notification.service";
import { AxiosService, AxiosServiceReturn } from "./axios.service";
import { JwtHelperService } from "@auth0/angular-jwt";
// import { NotificationService } from '../shared/services/notification.service';
// import { AxiosService } from '../axios.service';


// export type AuthorizationUserProperty = "roleNames" | "accessLevelNames";
export type AuthorizationUserProperty = "roleNames" | "accessLevelNames";
export interface UserResponse {
  UserId: string;
  Username: string;
  Email: string;
  Telephone: string;
  Roles: {
    Name: string;
    // priviliges?: any[],
  }[];
  access_levels: {
    name: string;
    value_id: string;
    value_name: string;
  }[];
  error?: boolean;
}
export interface UserErrorResponse {
  error: boolean;
  message: string;
}

const SAMPLE_RESPONSE: {
  data: UserResponse | UserErrorResponse;
  status?: number;
} = {
  data: {
    UserId: "6bb41bc9-7ad5-4024-ad4c-7a3acc0c1811",
    Username: "tesmay.farka",
    Email: "asmay0909@gmail.com",
    Telephone: "911111112",
    Roles: [
      {
        Name: "Woreda EMIS",
      },
    ],

    access_levels: [
      {
        name: "Region",
        value_id: "a61e5f1a-e343-11ed-81a3-80ce62417d76",
        value_name: "Oromia",
      },
    ],
  },
};

@Injectable({
  providedIn: "root",
})
export class AuthService {
  //!todo: either disassmble to Auth and User/Persmission Service or to Auth, User, and Permission Service

  private _user: UserResponse;
  private _token: string;
  private _role: string;
  private _userId: string;
  private _username : string;
  private _accessLevels: string[];

  constructor(
    private localStorageService: LocalStorageService,
    private notificationService: NotificationService,
    private axiosService: AxiosService,
    private jwtHelper: JwtHelperService
  ) {
    console.log("in AuthService constructor");
    // console.log("🔃loading🔃");
    this.loadToken();
    if(this._token) this.init(this._token);
  }

  async login(data: any, loading?: boolean) {
    try {
      const res: AxiosResponse = await this.axiosService.axios.post(
        "api/auth/login",
        data
      );
      if (res.status == 200) {
        return res;
      } else if (res.status != 200) {
        this.notificationService.showToastr(
          "danger",
          "Username Or Password not correct"
        );
        return res;
      }
    } catch (e) {

      if (e.response.status == 401) {
        this.notificationService.showToastr("danger", "Incorrect username or password");
        loading = false;
      } else {
        loading = false;
        this.notificationService.showToastr("danger", "Request not served. Check your internet connection.");
      }
    }
  }

  async init(token: string) {
    console.log("in AuthService init");

    this._token = token;
    console.log('this._token: ', this._token);
    console.log('token', token);
    
    // const res: boolean = await this.fetchUser();
    var decodedToken = this.jwtHelper.decodeToken(token);

    this._role = decodedToken['role'];
    this._userId = decodedToken['userId'];
    this._username = decodedToken['username'];
    this.saveToken(token);
    this.axiosService.init();
    return true;
  }


  saveToken(token: string) {
    console.log("in AuthService saveToken");
    this.localStorageService.save(LOCAL_STORAGE_KEYS.ACCESS_TOKEN, token);
  }


  loadToken() {
    console.log("in AuthService loadToken");
    this._token = this.localStorageService.get(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);
  }


  unload() {
    console.log("in AuthService unload");
    this._token = null;
    this._user = null;
    this._role = null;
    this._username = null;
    this._accessLevels = null;
    this.deleteToken();
    this.axiosService.init();
  }
  deleteToken() {
    console.log("in AuthService deleteToken");
    this.localStorageService.remove(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);
  }
  isLoggedIn() {
    console.log("in AuthService isLoggedIn", this._token);
    console.log("it there a token?", this._token ? true : false)
    return this._token ? true : false;
  }
  get token() {
    console.log("in AuthService token");
    return this._token;
  }

  get user() {
    return this._user;
  }
  get userName() {
    return this._user?.Username;
  }

  get role() {
    return this._role;
  }


  get username(){
    return this._username;
  }
  getuserId() {
    this.loadToken();
    var decodedToken = this.jwtHelper.decodeToken(this._token);
    this._userId = decodedToken['userId'];
    console.log('👨‍🦰🤴👨‍🦳👩‍🦰', this._userId)
    return this._userId;
  }

  get accessLevels() {
    return this._user?.access_levels;
  }
  get accessLevelNames() {
    return this._accessLevels;
  }
  async logout() {
    console.log("in AuthService logout");
    console.log("...logging out...");
    await this.logoutFromBackend()
    this.unload();
  
  }


  async logoutFromBackend() {
    const res: AxiosServiceReturn = await this.axiosService.request(
      "POST",
      `api/auth/logout`,
      null,
      {
        notificationConfig: {
          successHandlingConfig: {
            showGlobalSuccessMessageNotification: false
          }
        }
      }
    )


    return res;
  }
}
